/** Add / edit a contact. */
import { useState } from 'react';
import { useApp } from '../../store/AppContext.jsx';
import { salesTeam } from '../../domain/crm.js';
import Sheet, { Group, Field, OptionSelect, RecordSelect, QuickActions } from '../Sheet.jsx';
import { useNavigate } from 'react-router-dom';
import AskAI from "../AskAI.jsx";

export default function ContactSheet({ id, onClose }) {
  const { S, crm, saveContact, saveCompany, addContactToPipeline, toast } = useApp();
  const navigate = useNavigate();
  const existing = id ? crm.contacts.find(c => c.id === id) : null;

  const [form, setForm] = useState(() => existing || {
    name: '', title: '', email: '', phone: '', cid: '',
    /* Empty, not whoever is signed in: writing somebody down is not the
       same as taking them on, and a name the box filled in is a name nobody
       chose - the list then reads as assigned when nothing was. */
    status: 'New', source: '', owner: '', notes: ''
  });

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const save = () => {
    if (!String(form.name).trim()) { toast('Name the contact'); return; }
    saveContact(id, { ...form, name: String(form.name).trim() });
    onClose();
  };

  return (
    <Sheet
      icon="users"
      tone="g-blue"
      title={id ? 'Edit contact' : 'New contact'}
      onClose={onClose}
      onSave={save}
      saveLabel="Save contact"
      footerLeft={id ? <AskAI module="contact" id={id} subject={form.name} ghost label="Read this contact" /> : null}
    >
      <Group>Contact</Group>

      <Field label="Name">
        <input autoFocus value={form.name || ''} onChange={e => set('name', e.target.value)} />
      </Field>
      <Field label="Job title">
        <input value={form.title || ''} onChange={e => set('title', e.target.value)} />
      </Field>
      <Field label="Email">
        <input value={form.email || ''} onChange={e => set('email', e.target.value)} />
      </Field>
      <Field label="Phone">
        <input value={form.phone || ''} onChange={e => set('phone', e.target.value)} />
      </Field>
      <Field label="Company">
        <RecordSelect
          value={form.cid}
          onChange={v => set('cid', v)}
          records={crm.companies}
          onCreate={name => saveCompany(null, { name, industry: '', size: '', city: '', owner: '', web: '' }, { quiet: true })}
        />
      </Field>
      <Field label="Status">
        <OptionSelect value={form.status} onChange={v => set('status', v)} options={S.lStatus || []} />
      </Field>
      <Field label="Source">
        <OptionSelect value={form.source} onChange={v => set('source', v)} options={S.sources || []} blank="" />
      </Field>
      <Field label="Owner">
        <OptionSelect value={form.owner} onChange={v => set('owner', v)} options={salesTeam(S, crm, form.owner)} blank="" />
      </Field>
      <Field label="Notes" wide>
        <textarea value={form.notes || ''} onChange={e => set('notes', e.target.value)} />
      </Field>
      {id ? (
        <Field label="Next" wide>
          <QuickActions>
            <button
              type="button"
              onClick={() => {
                onClose();
                const dealId = addContactToPipeline(id);
                if (dealId) navigate('/pipeline', { state: { keepFilter: true } });
              }}
            >
              Add to pipeline
            </button>
          </QuickActions>
        </Field>
      ) : null}
    </Sheet>
  );
}
